/**
 * Slices a daily-bucketed array (oldest-first, as returned by bucketCostByDay) down
 * to the trailing N calendar months ending today — used to derive "Last 3 Months" /
 * "Last 6 Months" from an already-fetched 12-month array without an extra query.
 */
export function sliceLastNMonths(dailyData, months, now = new Date()) {
  const cutoff = new Date(now.getFullYear(), now.getMonth() - months, now.getDate());
  const cutoffKey = cutoff.toISOString().slice(0, 10);
  return (dailyData || []).filter((day) => day.date > cutoffKey);
}

// Real per-day usage. There's no daily-bucketed usage endpoint on the AI service, so
// this buckets the existing per-task/context rows (getUsageByContext — same endpoint
// AIUsage.jsx's context table already fetches) by each row's first_call day. Every
// context/task row carries a real cost + date, so this is real aggregated data, just
// grouped client-side instead of server-side.
export function bucketCostByDay(contextRows, dateFromIso, dateToIso) {
  const byDay = new Map();
  (contextRows || []).forEach((row) => {
    const dayKey = (row.first_call || row.last_call || "").slice(0, 10);
    if (!dayKey) return;
    byDay.set(dayKey, (byDay.get(dayKey) || 0) + parseFloat(row.cost || 0));
  });

  const start = new Date(dateFromIso);
  const end = new Date(dateToIso);
  const cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const days = [];
  while (cursor <= endDate) {
    const key = cursor.toISOString().slice(0, 10);
    days.push({ date: key, cost: byDay.get(key) || 0 });
    cursor.setDate(cursor.getDate() + 1);
  }
  return days;
}
